import { Box, Divider, Stack, Typography } from '@mui/material'
// import DeliveryImg from '../../assets/images/free-delivery.png'
import DeliveryImg from '../../assets/images/med-delivery.jpg'
import PillImg from '../../assets/images/pill.jpg'
import MedicineImg from '../../assets/images/medicine.jpg'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import MedicalCalender from '../../assets/icons/Bck/med-monthly.svg';
import styles from './index.module.css'
import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { BreadcrumbContext } from '../../components/Breadcrumb';
import useBreadcrumb from '../../hooks/useBreadcrumb';

export const themeOptions = {
    palette: {
        mode: 'light',
        primary: {
            main: '#3f51b5',
        },
        secondary: {
            main: '#f50057',
        },
    },
    typography: {
        fontFamily: 'Droid Serif',
        fontWeightLight: 300,
    },
};

function Pharmacy() {
    const { setBreadcrumb, clearBreadcrumb } = useBreadcrumb();

    useEffect(() => {
        setBreadcrumb({ title: "Pharmacy", links: [{ title: "Home", url: "/" }, { title: "Pharmacy" }] })

        return clearBreadcrumb;
    }, []);

    return (
        <Stack className={styles.container}>
            <Box sx={{ background: '#f5f5f5' }}>
                <Box className={styles.content} >
                    <Stack spacing={2} sx={{ textAlign: 'center', mt: '4rem', mb: '4rem' }}>
                        <Typography variant='h5' sx={{ color: '#0a9a73' }}>
                            Let us be a partner in care to help manage your patient’s therapy goals
                        </Typography>
                        <Typography variant='body1'>
                            Our therapy management programs and clinical expertise will support
                            your patients through their treatment journey. Our local presence allows
                            us to build strong provider relationships and provide prompt
                            communication. Our extensive medication inventory helps provide faster
                            medication access for your patients.
                        </Typography>
                    </Stack>
                </Box>
                <Box sx={{ background: '#0a9a73', py: '40px' }}>
                    <Box className={styles.content} >
                        <Typography variant="h4" sx={{ color: 'white', py: "1rem", textAlign: 'center', pb: '2rem' }}>Finally, a pharmacy team that works for you</Typography>
                        <Stack direction="row" gap={2} sx={{ py: '1rem', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                            <Box sx={{ p: '35px 40px', borderRadius: '10px', background: 'white', width: { xs: '100%', md: '40%' } }}>
                                <Typography variant="h5" sx={{ color: '#0a9a73 !important', mb: '10px' }}>Dedicated Customer Service</Typography>
                                <Typography variant="body1">Reach us anytime for quick and reliable assistance</Typography>
                            </Box>
                            <Box sx={{ p: '35px 40px', borderRadius: '10px', background: 'white', width: { xs: '100%', md: '40%' } }}>
                                <Typography variant="h5" sx={{ color: '#0a9a73 !important', mb: '10px' }}>Rx Cost & Coverage Support</Typography>
                                <Typography variant="body1">We check insurance coverage, costs, and program eligibility</Typography>
                            </Box>
                            <Box sx={{ p: '35px 40px', borderRadius: '10px', background: 'white', width: { xs: '100%', md: '40%' } }}>
                                <Typography variant="h5" sx={{ color: '#0a9a73 !important', mb: '10px' }}>Medication Synchronization</Typography>
                                <Typography variant="body1">No more multiple trips to the pharmacy.</Typography>
                            </Box>
                            <Box sx={{ p: '35px 40px', borderRadius: '10px', background: 'white', width: { xs: '100%', md: '40%' } }}>
                                <Typography variant="h5" sx={{ color: '#0a9a73 !important', mb: '10px' }}>Immunizations</Typography>
                                <Typography variant="body1">Administered by trained healthcare professionals.</Typography>
                            </Box>
                        </Stack>
                    </Box>
                </Box>
            </Box>
            <Box className={styles.content} sx={{ pt: '40px' }} >
                <Stack spacing={5}>
                    <Stack spacing={2}>
                        <Typography variant='h4' sx={{ pb: '30px' }}>
                            We use convenience to improve compliance
                        </Typography>
                        <Stack direction="row" spacing={2}>
                            <Box>
                                <img height={100} width={100} src={DeliveryImg} alt="img" />
                            </Box>
                            <Stack spacing={2}>
                                <Typography variant='subtitle1' sx={{ fontSize: '18px', color: '#0a9a73 !important' }}>
                                    Blister Packs
                                </Typography>
                                <Typography variant='body1'>
                                    Our blister packs come as a monthly package, separating medication dosing up to four administration times daily (morning, noon, evening,
                                    and bedtime). This ensures the right medications are given at the right time. Some of the benefits to custom blister packaging include:
                                </Typography>
                            </Stack>
                        </Stack>
                        <Stack spacing={2} sx={{ pl: '116px', pt: '10px' }} >
                            <Stack direction="row" spacing={3}>
                                <AccessTimeIcon sx={{ color: '#0a9a73 !important' }} />
                                <Typography variant="body1">
                                    Special packaging ensures the right medication are taken at the right time
                                </Typography>
                            </Stack>
                            <Divider sx={{ borderColor: 'rgb(0 0 0 / 50%)' }} />
                            <Stack direction="row" spacing={3}>
                                <VaccinesIcon sx={{ color: '#0a9a73 !important' }} />
                                <Typography variant="body1">
                                    Reduce the risk of a missed dose or double dosing
                                </Typography>
                            </Stack>
                            <Divider sx={{ borderColor: 'rgb(0 0 0 / 50%)' }} />
                            <Stack direction="row" spacing={3}>
                                <SentimentSatisfiedAltIcon sx={{ color: '#0a9a73 !important' }} />
                                <Typography variant="body1">
                                    Patients can manage their health more independently, as their prescriptions are pre-organized by a pharmacist
                                </Typography>
                            </Stack>
                            <Divider sx={{ borderColor: 'rgb(0 0 0 / 50%)' }} />
                             <Stack direction="row" spacing={3}>
                                <Box display="flex" alignItems="center">
                                    <img
                                      height={24}
                                      width={24}
                                      src={MedicalCalender}
                                      alt="img"
                                    />
                                </Box>  
                                <Typography variant="body1">
                                    Monthly check in to see if there any changes to PT Medication/dose 
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Box>
                            <img height={100} width={100} src={PillImg} alt="img" />
                        </Box>
                        <Stack spacing={2}>
                            <Typography variant='subtitle1' sx={{ color: '#0a9a73 !important', fontSize: '18px', }}>
                                Free Prescription Delivery
                            </Typography>
                            <Typography variant='body1'>
                                <Typography variant='body1' component="span" sx={{ color: '#0a9a73 !important' }}>MySavCare</Typography> offers quick, free, and convenient prescription delivery to your patients' residence or your office
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Box>
                            <img height={100} width={100} src={MedicineImg} alt="img" />
                        </Box>
                        <Stack spacing={2} sx={{ pb: '50px'}}>
                            <Typography variant='subtitle1' sx={{ color: '#0a9a73 !important', fontSize: '18px' }}>
                                Specialty Medication
                            </Typography>
                            <Typography variant='body1'>
                                As an URAC Specialty Accredited Pharmacy, <Typography variant='body1' component="span" sx={{ color: '#0a9a73 !important' }}>MySavCare</Typography> Pharmacy provides comprehensive patient care and monitoring programs. We provide
                                complex services to support patients with high burden health conditions. <Typography variant='body1' component="span" sx={{ color: '#0a9a73 !important' }}>MySavCare</Typography> makes specialty medications more accessible and we are
                                equipped to source and handle a large range of specialty medications.
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack spacing={2} sx={{ pt: '40px', pb: '50px' }}  style={{ display: 'none' }}>
                        <Typography variant='h5' sx={{ color: '#0a9a73 !important' }}>Substance Abuse & Antipsychotic Injectables</Typography>
                        <Typography variant='body1'>Our Certified Pharmacists can provide full administration* of your patients’ maintenance Antipsychotic & Substance Use Disorder Injections. (*After initial
                            dose by provider.) Once enrolled, we will keep track of the patient’s injection dates as well as schedule and arrange maintenance injections, working with
                            caregivers if needed.</Typography>
                    </Stack>
                </Stack>
            </Box>
            <Box sx={{ background: '#f0f0f0' }}>
                <Stack className={styles.content} direction="row" sx={{ mt: '2rem', p: '2rem', textAlign: 'center' }}>
                    <Stack spacing={3} sx={{
                        alignItems: 'center', width:
                            '100%'
                    }}>
                        <Typography variant='h5' sx={{ color: '#0a9a73 !important' }}>Medical Referral Forms</Typography>
                        <Typography variant='body1'>
                            Easily send over patient information in medical referral forms custom-made by
                            MySavCare to serve those with specialty disease states or utilizing specialty.
                        </Typography>
                        <Typography variant='body2' sx={{ textAlign: 'center' }}>Do you have any questions? Please feel free to <Typography component={Link} to="/contact" variant='body1' sx={{ color: '#0a9a73 !important', textDecoration: "none" }}>get in touch with us.</Typography></Typography>
                    </Stack>
                </Stack>
            </Box>
        </Stack>
    )
}

export default Pharmacy;
